export default __webpack_public_path__ + "static/media/learose3-2048w.c0f4c091.avif";